import Vue from 'vue'
import axios from '@/http-common'

import { USER_REQUEST, USER_ERROR, USER_SUCCESS, USER_TOGGLE_DRAWER, USER_SET_DRAWER, USER_START_LOADING, USER_FINISH_LOADING, USER_ANULAR_AVISO_CUESTIONARIOS_PENDIENTES} from '../actions/user'
import { AUTH_LOGOUT } from '../actions/auth'
import { COMUNIDADES_REQUEST } from '../actions/comunidades';
import { CUESTIONARIOS_REQUEST } from '../actions/cuestionarios';

const state = { 
  status: '',
  drawer: null,
  loading: 0,
  mostrarAvisoCuestionariosPendientes: true,
  profile: {}
}

const getters = {
  drawer: state => state.drawer,
  isLoading: state => state.loading > 0
}

const actions = {
  [USER_REQUEST]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(USER_REQUEST)
      axios.get('/personas', {})
      .then(response => {
        commit(USER_SUCCESS, response.data)

        dispatch(COMUNIDADES_REQUEST)
        dispatch(CUESTIONARIOS_REQUEST)

        resolve(response)
      })
      .catch(error => {
        commit(USER_ERROR)

        // if resp is unauthorized, logout, to
        dispatch(AUTH_LOGOUT)

        reject(error)
      })
    })
  },
  [USER_TOGGLE_DRAWER]: ({commit}) => {
    commit(USER_TOGGLE_DRAWER)
  },
  [USER_SET_DRAWER]: ({commit}, drawer) => {
    commit(USER_SET_DRAWER, drawer)
  },
  [USER_START_LOADING]: ({commit}) => {
    commit(USER_START_LOADING)
  },
  [USER_FINISH_LOADING]: ({commit}) => {
    commit(USER_FINISH_LOADING)
  },
  [USER_ANULAR_AVISO_CUESTIONARIOS_PENDIENTES]: ({commit}) => {
    commit(USER_ANULAR_AVISO_CUESTIONARIOS_PENDIENTES)
  }
}

const mutations = {
  [USER_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [USER_SUCCESS]: (state, payload) => {
    state.status = 'success'

    Vue.set(state, 'profile', payload)
  },
  [USER_ERROR]: (state) => {
    state.status = 'error'
  },
  [USER_TOGGLE_DRAWER]: (state) => {
    state.drawer = !state.drawer
  },
  [USER_SET_DRAWER]: (state, drawer) => {
    state.drawer = drawer
  },
  [USER_START_LOADING]: (state) => {
    state.loading++
  },
  [USER_FINISH_LOADING]: (state) => {
    state.loading--
  },
  [USER_ANULAR_AVISO_CUESTIONARIOS_PENDIENTES]: (state) => {
    state.mostrarAvisoCuestionariosPendientes = false
  },
  [AUTH_LOGOUT]: (state) => {
    state.status = ''
    state.profile = {}
    state.mostrarAvisoCuestionariosPendientes = true
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
